import { debounceTime, filter, Observable, scan, Subject } from 'rxjs';
import { inject, Injectable, Injector } from '@angular/core';

import type { ImageSnippet } from '../_mappers/snippet.mapper';
import { SnippetMapper } from '../_mappers/snippet.mapper';
import { IMedia } from '../_interfaces/media.interface';

@Injectable({
  providedIn: 'root'
})
export class ImageDsService {
  private readonly injector = inject(Injector);
  private readonly subject = new Subject<IMedia>();

  sendImageDatas(image: IMedia): void {
    this.subject.next(image);
  }

  getImageDatas(): Observable<IMedia> {
    return this.subject.asObservable();
  }

  loadImageSnippets(): Observable<ImageSnippet[]> {
    return this.getImageDatas().pipe(
      filter((image) => (
        image?.mime !== 'image/svg+xml' && image?.urlTwicPic?.length > 0
      )),
      scan((acc, image) => {
        const snippetMapper = this.injector.get(SnippetMapper);

        return [...acc, snippetMapper.mapImageSnippet(image)];
      }, [] as ImageSnippet[]),
      debounceTime(1000)
    );
  }
}
